import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import Navbar from './components/Navbar';
import About from './pages/About';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import Chart from './pages/Chart';
import ChatAgent from './components/chatAgent';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/*" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/chart" element={<Chart />} />
        <Route path="/chat" element={<ChatAgent />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
